export default {
  en: {
    klasha__button: 'Confirm Payment',

    klasha__otp_step_1:
      'We’ve sent a One-Time Password (OTP) via SMS to your MoMo phone number: <b>{phone}</b>.',
    klasha__otp_step_2: 'Please check your phone for the SMS message.',
    klasha__otp_step_3: 'Enter the OTP code you received in the field below',
    klasha__otp_step_4: 'Click <b>“Confirm Payment”</b> to proceed and return merchant website.',
    klasha__otp_step_5: 'Your payment will be processed automatically.',

    klasha__step_1:
      'We have sent a payment approval request to your MoMo phone number: <b>{phone}</b>.',
    klasha__step_2:
      'Please <b>check your phone now</b>. You should receive a prompt (this might be a USSD menu pop-up or an in-app notification) asking you to approve the payment.',
    klasha__step_3:
      '<b>Enter your MoMo PIN on your phone</b> when prompted to authorize the transaction.',
    klasha__step_4: 'Click <b>“Confirm Payment”</b> to proceed and return merchant website.',
    klasha__step_5: 'Your payment will be processed automatically.',
    otp_code: 'OTP Code',
  },
};
